import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import {
  TableHeaderRow,
  TableRows,
  PaginationRow,
  TableSearch,
  useTable,
} from '../';

// ***********************************************
// Table Components
// ***********************************************

export const SimulcastTable = ({
  bodySchema,
  debugging,
  headerSchema,
  initialMediaState,
  initialSortColumn,
  initialSortDirection,
  initialSearchParams,
  isLoading,
  methods,
  pageSelectTitle,
  rowData,
  searchFields,
  state,
  totalItems,
  onSearchTextChanged = () => null,
  onClearSearch = () => null,
  exportButton,
  paginationRowChildren,
  children,
}) => {
  const [isClearing, setIsClearing] = useState(false);

  const {
    activePage,
    actualPageSize,
    loadData,
    onPageChanged,
    onPageSizeChanged,
    onSearch,
    onSortClick,
    pageSize,
    setSortColumn,
    setSortDirection,
    sortDirection,
  } = useTable({
    debugging,
    initialSortColumn,
    initialSortDirection,
    initialMediaState,
    initialSearchParams,
    methods,
    totalItems,
  });

  const data = { rowData, state };
  const showSearch = searchFields?.length > 0;

  return (
    <div style={{ fontSize: '0.8em' }}>
      {showSearch && (
        <TableSearch
          data-testid="search-container"
          fields={searchFields}
          initialSearchParams={initialSearchParams}
          onSearch={(data) => {
            setIsClearing(false);
            onSearch(data);
            onSearchTextChanged(data);
          }}
          onClear={() => {
            setIsClearing(true);
            onClearSearch();
          }}
          isLoading={isLoading}
        >
          {children}
        </TableSearch>
      )}
      {/* {children} */}
      <PaginationRow
        activePage={activePage}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChanged={onPageChanged}
        onPageSizeChanged={onPageSizeChanged}
        pageSelectTitle={pageSelectTitle}
        location="top"
        exportButton={exportButton}
      >
        {paginationRowChildren}
      </PaginationRow>
      <div>
        <Table data-testid="table" id="table-to-xls" sortable>
          <Table.Header data-testid="table-header">
            <Table.Row>
              <TableHeaderRow
                data-testid="table-header-row"
                onSortClick={onSortClick}
                schema={headerSchema}
                setSortColumn={setSortColumn}
                setSortDirection={setSortDirection}
                sortDirection={sortDirection}
              />
            </Table.Row>
          </Table.Header>
          <TableRows
            loadData={loadData}
            activePage={activePage}
            data={data}
            isLoading={isLoading}
            pageSize={actualPageSize}
            schema={bodySchema}
            topic={pageSelectTitle}
            isClearing={isClearing}
          />
        </Table>
      </div>
      <PaginationRow
        activePage={activePage}
        onPageChanged={onPageChanged}
        onPageSizeChanged={onPageSizeChanged}
        pageSelectTitle={pageSelectTitle}
        pageSize={pageSize}
        totalItems={totalItems}
        location="bottom"
        exportButton={exportButton}
      >
        {paginationRowChildren}
      </PaginationRow>
    </div>
  );
};

SimulcastTable.propTypes = {
  bodySchema: PropTypes.array.isRequired,
  debugging: PropTypes.bool,
  headerSchema: PropTypes.array.isRequired,
  initialMediaState: PropTypes.string,
  initialSortColumn: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  methods: PropTypes.object.isRequired,
  pageSelectTitle: PropTypes.string.isRequired,
  rowData: PropTypes.array.isRequired,
  searchFields: PropTypes.array,
  state: PropTypes.object,
  totalItems: PropTypes.number.isRequired,
};

SimulcastTable.defaultProps = {
  debugging: false,
  searchFields: [],
  state: null,
};
